<template>
  <div>
    <template v-if="errors.code">
      <a-result :status="String(errors.code)" :title="errors.code" :sub-title="errors.message">
        <template #extra>
          <a-button type="primary" @click="$router.back()">
            Back to previous page
          </a-button>
        </template>
      </a-result>
    </template>
    <template v-else>
      <div
        class="mb-4"
        style="position: sticky; top: 78px; z-index: 5; background-color: white; margin: -20px -35px 0; padding: 15px 30px;"
      >
        <a-breadcrumb
          separator=">"
        >
          <a-breadcrumb-item>
            <router-link :to="{ path: '/product', query: { business_id: businessId, workspace_id: $route.query.workspace_id } }">
              {{ $t('product.title') }}
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <router-link :to="{ path: '/product', query: { business_id: businessId, workspace_id: $route.query.workspace_id } }">
              {{ $t('product.listProduct') }}
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            {{ business.business_title }}
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            Ubah Produk
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>

      <CreateProductForm
        ref="form"
        :loading="loading"
        :business="business"
        :product="product"
        :permission="permission"
        :get-detail="fetchProductDetail"
      />
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import CreateProductForm from '@/components/Store/Distributor/ProductForm/index.vue'
import { getProductDetail } from '@/api/product'
import { getDetailProductRedeem, getDetailProductDistributorApp } from '@/api/channels/distributor'
import { getInventoryListV2 } from '@/api/inventory'

export default defineComponent({
  name: 'EditProductPage',
  components: { CreateProductForm },
  beforeRouteLeave(to, from, next) {
    return this.$refs.form ? this.$refs.form.beforeRouteLeave(to, from, next) : next()
  },
  data() {
    return {
      product: {},
      errors: {
        message: null,
        code: null,
      },
      loading: false,
    }
  },
  computed: {
    productId() {
      const id = this.$route.query.id
      return Array.isArray(id) ? id.join(',') : id
    },
    
    businessId() {
      return String(this.$route.query['business_id'] || '')
    },

    business() {
      return this.$store.state.user.businessList.find(business => business.business_id === this.businessId) || {}
    },
    permission() {
      return this.$store.getters['user/can']('product-list')
    },
  },
  mounted() {
    this.$store.commit('products/SET_CHANNEL', true)
    this.fetchProductDetail()
  },
  methods: {
    async fetchProductDetail() {
      this.loading = true
      if (!this.productId) return

      this.errors.message = null

      try {
        const { data: { data: productResponse } } = await getDetailProductDistributorApp({
          channel_id: this.$route.params.id,
          product_id: this.productId,
        })

        let detailProduct = {
          product_id: this.productId,
          master_product_id: productResponse.master_product_id,
          detail: {
            title: productResponse.title,
            long_description: productResponse.description?.long_description,
            short_description: productResponse.description?.short_description,
            category: {
              id: productResponse.category_data?.id,
              name: productResponse.category_data?.name,
            },
            slug: productResponse.slug,
            brand_id: productResponse.brand_id,
            imported: productResponse.imported,
            new: productResponse.new,
          },
          catalogs: productResponse.catalogs?.map(v => ({
            ...v,
            sku: v.sku,
            option: v.option,
            title: v.title,
          })) || [],
          images: productResponse.all_images?.map(img => ({
            id: img.id,
            name: img.name,
            url: img.url,
            is_thumb: img.is_thumb,
            is_show: img.is_show,
          })) || [],
          inventory: [],
        }

        this.product = detailProduct
      } catch (error) {
        console.error({ error })
        const code = error?.response?.status
        this.loading = false
        this.errors.code = code
        this.errors.message = code === 404 ? 'Produk tidak ditemukan' : (error?.response?.data?.message || 'Terjadi kesalahan')
      } finally {
        this.loading = false
      }
    },
  },
})
</script>
